import Api from '~/api'

export function filesUploaded(files) {
  return {
    type: 'FILES_UPLOADED',
    table_id: 'files',
    files,
  }
}

export function deleteFile(fileId) {
  return new Promise((resolve, reject) => {
    Api.delete(`/file/${fileId}`)
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function updateFileName(fileId, fileName) {
  return new Promise((resolve, reject) => {
    Api.post(`/file/${fileId}`, { fileName })
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
